/* eslint-disable no-unused-vars */
import { Button, Col, DatePicker, Input, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { FaCogs, FaEye, FaPenAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { useApi } from "../../../../hooks/http2";
import {
  actionStoreQrLot,
  searchSelector,
} from "../../../../redux/slices/store-qr/lot";
import { getUser, moment, URL_API } from "../../../../utils";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import SelectBranch from "../components/SelectBranch";

const LotList = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const [query, setQuery] = useState("")
  const [branch, setBranch] = useState("");
  const { SET_SEARCH } = actionStoreQrLot;

  const list = useApi(
    {
      url: `${URL_API}/store-qr/lot`,
      token: true,
      params: {
        ...search,
        offset: (search.page - 1) * search.limit,
        start_date: search.start_date
          ? new Date(moment(search.start_date).format("YYYY-MM-DD"))
          : null,
        end_date: search.end_date
          ? new Date(moment(search.end_date).format("YYYY-MM-DD"))
          : null,
      },
    },
    [search]
  );
  
  useEffect(() => {
    let user = getUser();

    dispatch(SET_SEARCH({ branch: user?.branch_code, page: 1 }));
    setBranch(user.branch_code);
  }, [dispatch, SET_SEARCH]);

  return (
    <Panel>
      <PanelHeader>เก็บข้อมูล Lot.</PanelHeader>
      <PanelBody>
        <Row gutter={16} className="mb-3">
          <Col md={6}>
            <Input.Search
              placeholder="รหัสสินค้า, ชื่อสินค้า, Lot., QR code ย่อย"
              defaultValue={search.query}
              //value={search.query}
              allowClear
              onSearch={(value) =>
                dispatch(SET_SEARCH({ query: value, page: 1 }))
              }
              // onChange={e =>setQuery(e.target.value || "")}
              // onChange={(e) =>
              //   dispatch(SET_SEARCH({ query: e.target.value || "", page: 1 }))}
            />
          </Col>
          <Col md={5}>
            <SelectBranch
              className="w-100"
              withAll
              allText="สาขาทั้งหมด"
              placeholder="สาขา"
              value={search.branch}
              onChange={(value) =>
                dispatch(SET_SEARCH({ branch: value, page: 1 }))
              }
            />
          </Col>
          <Col md={5}>
            <DatePicker
              className="w-100"
              placeholder="หมดอายุเริ่มต้น"
              format="DD/MM/YYYY"
              value={search.start_date}
              onChange={(value) =>
                dispatch(SET_SEARCH({ start_date: value, page: 1 }))
              }
            />
          </Col>
          <Col md={5}>
            <DatePicker
              className="w-100"
              placeholder="หมดอายุสิ้นสุด"
              format="DD/MM/YYYY"
              value={search.end_date}
              onChange={(value) =>
                dispatch(SET_SEARCH({ end_date: value, page: 1 }))
              }
            />
          </Col>
          <Col md={3}>
            <Button
              type="primary"
              block
              onClick={() => history.push(`${match.path}/0`)}
            >
              เพิ่มข้อมูล
            </Button>
          </Col>
        </Row>
        <Table
          bordered
          size="small"
          loading={list.loading}
          dataSource={list.fetch?.data || []}
          pagination={{
            size: "default",
            current: search.page,
            pageSize: search.limit,
            total: list.fetch?.total || 0,
            showLessItems: true,
            showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total}`,
            onChange: (p) => dispatch(SET_SEARCH({ page: p })),
          }}
          rowKey="id"
        >
          <Table.Column
            title="No."
            align="right"
            key="no"
            //render={(text, record, index) => index + 1}
            dataIndex="row_id"
          />
          <Table.Column
            title="รหัสสินค้า"
            align="center"
            dataIndex="product_code"
          />
          <Table.Column title="ชื่อสินค้า" dataIndex="product_name" />
          <Table.Column title="Lot." dataIndex="lot" />
          <Table.Column
            title="วันที่ผลิตสินค้า"
            align="center"
            dataIndex="production_date"
            render={(text) => moment(text).format("DD/MM/YYYY")}
          />
          <Table.Column
            title="วันหมดอายุสินค้า"
            align="center"
            dataIndex="expiration_date"
            render={(text) => moment(text).format("DD/MM/YYYY")}
          />
          <Table.Column title="สาขา" dataIndex="branch_name" align="center" />
          <Table.Column
            title="ผู้ดำเนินการ"
            dataIndex="create_by"
            align="center"
          />
          <Table.Column
            title="วันที่เก็บข้อมูล"
            align="center"
            dataIndex="document_date"
            className="text-nowrap"
            render={(text) => moment(text).format("DD/MM/YYYY HH:mm")}
          />
          <Table.Column
            title="สถานะ"
            align="center"
            dataIndex="status"
            className="text-nowrap"
          />
          <Table.Column
            title={<FaCogs />}
            align="right"
            className="text-nowrap"
            render={(text, record) => (
              <>
                {(record.status === "draft" && record.branch_code === branch) && (
                  <Button
                    type="default"
                    size="small"
                    shape="circle-outline"
                    className="mr-2"
                    onClick={() => history.push(`${match.path}/${record.id}`)}
                  >
                    <FaPenAlt />
                  </Button>
                )}

                <Button
                  type="primary"
                  size="small"
                  shape="circle-outline"
                  onClick={() =>
                    history.push(`${match.path}/${record.id}/view`)
                  }
                >
                  <FaEye />
                </Button>
              </>
            )}
          />
        </Table>
      </PanelBody>
    </Panel>
  );
};

export default LotList;
